import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  linkIndeedFlexPosition,
  type LinkIndeedFlexPositionParams,
} from 'api/admin/indeedFlex/linkIndeedFlexPosition'
import { indeedFlexKeys } from './keys'

export const useLinkIndeedFlexPositionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: LinkIndeedFlexPositionParams) =>
      linkIndeedFlexPosition(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.shiftIssues(),
      })
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.jobShifts(),
      })
    },
  })
}
